import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ConfirmDeleteDialog = ({ open, onCancel, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Potwierdzenie</DialogTitle>
            <DialogContent>
                Czy na pewno chcesz usunąć plik?
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Anuluj</Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Usuń
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
